module.exports = __webpack_public_path__ + "static/media/x.bbbf1975.svg";